<h2 mat-dialog-title class="qr-header">
  <span class="qr-title">
    <span>{{ data.title | translate }}</span>
    <span class="text-primary">{{ data.message | uppercase }}</span>
  </span>
  <span *ngIf="getQRDownloadURL() as src" class="qr-actions">
    <a [attr.href]="src" download="qr_{{ data.message }}.png" mat-icon-button>
      <i class="ri-download-2-line"></i>
    </a>
    <button mat-icon-button matDialogClose>
      <i class="ri-close-line"></i>
    </button>
  </span>
</h2>
<mat-dialog-content class="qr-content">
  <qrcode #qr [qrdata]="data.link" [width]="256"></qrcode>
</mat-dialog-content>
